module.exports = __webpack_public_path__ + "img/xk.6f10dceb.svg";